import Loader from "@/atoms-react/loader/Loader.react";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { useCheckCompanyWaitingPayment } from "@/features/company/hooks/use-company-waiting-payment";
import { getRoute, OlkyPassRoutes } from "@/utils/routes";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateCompanyPaidRoutes = () => {
  const { leUuid } = useCompanyContext();
  const { isWaitingPayment, isLoading } = useCheckCompanyWaitingPayment();

  if (isLoading) {
    return (
      <div className="mt-10 flex w-full justify-center">
        <Loader />
      </div>
    );
  }

  return isWaitingPayment ? (
    <Navigate to={getRoute(OlkyPassRoutes.company_onboarding, { company: leUuid })} replace />
  ) : (
    <Outlet />
  );
};
